/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Seat_PreyInputs */



/**
* | output |
* | --- |
* | "Prey" |
*
* @param {Tournament_Seat_PreyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_seat_prey = /** @type {((inputs?: Tournament_Seat_PreyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Seat_PreyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Presa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Presa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preda")
	return /** @type {LocalizedString} */ ("Prey")
});